<div class="wrapper text-center">
  <!-- Thankyou image -->
  <div class="img-container">
    <img loading="lazy" data-src="/assets/images/thank-you/ty-img-blue.png"/>
  </div>

  <!-- Donation message -->
  <div class="donation-message-container">
    <div class="donation-message"><strong>Your Contribution: <app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>{{order?.donated_amount_local}} + <app-currency-icon [currency]="order?.iso_currency"></app-currency-icon>{{prizeAmount}}</strong></div>
    <div class="donation-sub-message">The details of your contribution would be sent to you via Email.</div>
  </div>

  <!-- SIP card -->
  <div class="sip-card-wrapper">
    <div class="card-header text-left">
      <div class="title">Signup For SIP</div>
      <div class="subtitle">With Ketto’s SIP plan, you can make contributions monthly and help save more lives</div>
    </div>
    <div class="donate-card">
      <div class="d-flex benefits-container">
        <div class="benefits-list">
            <div class="text-left list-checks">
              <div class="d-flex">
                <div class="list"><i class="material-icons">done</i></div>
                <div class="list-text-container"><span class="list-text"><strong>12x Impact compared to regular contributions</strong></span></div>
              </div>
              <div class="list-contents">
                <div class="d-flex">
                  <div class="list"><i class="material-icons">done</i></div>
                  <div class="list-text-container contribute"><span class="list-text">Contribute to multiple fundraisers</span></div>
                </div>
                <div class="list"><i class="material-icons">done</i><span class="list-text">Start with just {{paymentV2.getMinSipAmount(order?.iso_currency)?.text}}/month</span></div>
                <div class="list"><i class="material-icons">done</i><span class="list-text">Receive regular Updates</span></div>
              </div>
            </div>
        </div>
        <div class="d-flex flex-wrap align-content-end flex-fill pb-2">
          <div class="live-count w-100"><app-lives-count [config]="{childCount: '12', label: 'LIVES EVERY YEAR', upperLabel: 'SAVE'}"></app-lives-count></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Monthly sign up button -->
  <div class="monthly-signup w-100">
    <button class="w-100" [routerLink]="[]" [queryParams]="{pr: 'c'}" queryParamsHandling="merge" (click)="onPaymentClick()" mat-raised-button>
      <span *ngIf="!vars.isOrderLoading">Sign Up With {{paymentV2.getMinSipAmount(order?.iso_currency)?.text}}/Month</span>
      <span *ngIf="vars.isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></span>
    </button>
  </div>

  <!-- Supporters -->
  <div>
    <app-payment-sip-donors />
  </div>

  <!-- Portfolio link -->
  <div class="portfolio-link w-100 text-center" [routerLink]="'/new/portfolio'">Go To Your Portfolio</div>
</div>
